<template>
	<div>
	 <b-row class="neu-cards-ctn landing-cnt" cols="1" cols-xl="4">
		<PatientPanelServiceBlock v-for="block in blocks" :id="block.id" visible :key="block.id" :title="block.title" :img="block.img" :action="block.action" :soonLabel="block.soonLabel" :description="block.description" :enabled="block.enabled" :backgroundColor="block.backgroundColor" :textAndIconColor="block.textAndIconColor"/>
	</b-row>
 </div>
</template>

<script>
import PatientPanelServiceBlock from '@/components/PatientPanelServiceBlock.vue'
import companyServicesMixin from '@/mixins/companyServices.mixin'
import appHelpers from '@/helpers/app.helpers'

export default {
	mixins: [companyServicesMixin],
	components: {
		PatientPanelServiceBlock
	},
	computed: {
		blocks () {
			const _this = this
			return [
				{
					id: 'medication-reminder',
					title: this.$t('patient-panel.medication-reminder'),
					action () {
						this.$router.push('/patient/clinic-history/medication-reminder')
					},
					img: '/static-appopensalud/img/icons/medication-reminder.svg'
				},
				{
					id: 'menstruation',
					title: this.$t('patient-panel.menstrual-calendar'),
					description: this.$t('patient-panel.menstrual-calendar-description'),
					img: '/static-appopensalud/img/icons/morillas-svg-icons/primary/menstrual-cycle.svg',
					enabled: this.$store.getters['session/userIsFemale'],
					action () {
						if (this.enabled) {
							this.$router.push('/patient/clinic-history/menstrual-calendar')
						} else {
							this.$store.dispatch('showSharedDialog', {
								content: this.$t(`patient-panel.menstrual-calendar-male-warning`),
								size: 'sm'
							})
						}
					}
				},
				{
					id: 'who-signs-up',
					title: this.$t('patient-panel.who-signs-up'),
					description: this.$t('patient-panel.who-signs-up-description'),
					img: '/static-appopensalud/img/healthy-community/who-in-simplified.svg',
					action () {
						if (this.enabled) {
							_this.goToWhoSignsUp()
						} else {
							_this.$store.dispatch('showOnlySubscriptorsDialog')
						}
					},
					enabled: this.$store.getters['session/healthyCommunityActive']
				},
				{
					id: 'blood-pressure',
					action () {
						this.$router.push('/patient/clinic-history/blood-pressure')
					},
					title: `${this.$t('patient-panel.blood-monitor')}`,
					img: '/static-appopensalud/img/icons/blood-pressure.svg',
					soonLabel: true
				},
				{
					id: 'forum',
					title: this.$t('patient-panel.patients-like-you'),
					description: this.$t('patient-panel.healthy-community-description'),
					img: '/static-appopensalud/img/icons/morillas-svg-icons/primary/healthy-community.svg',
					action () {
						appHelpers.goToForum()
					}
				},
				{
					id: 'wearables-devices',
					title: this.$t('patient-panel.wearables-devices'),
					img: '/static-appopensalud/img/icons/device.svg',
					enabled: false,
					action () {
					}
				},
				{
					id: 'nutritional-calculator',
					title: this.$t('patient-panel.nutritional-calculator'),
					img: '/static-appopensalud/img/icons/calculator.svg',
					soonLabel: true,
					action () {
					}
				},
				{
					id: 'functional-age',
					title: this.$t('patient-panel.functional-age'),
					img: '/static-appopensalud/img/icons/functional-age.svg',
					soonLabel: true,
					action () {
					}
				}
			]
		}
	}
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/webapp/patient/MyApplicationsPanelMenu.vue